import React from 'react';
import '../../App.css';
import '../opt-info/optInfoWrapp.css';

function OptInfoWrapp({data}) {
  return (
    <section className="info-opt-wrapp">
        <div className="container">
          {data.optput1 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.optput1 }}
          ></div>
        )}
            <div className="note">
                {data.optput2 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.optput2 }}
          ></div>
        )}
            </div>
            <div className="info-row row">
                <div className="col-md-6">
                    <div className="infor-col1">
                      {data.optput3 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.optput3 }}
          ></div>
        )}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="infor-col1">
                      {data.optput4 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.optput4 }}
          ></div>
        )}
                    </div>
                </div>
            </div>
        </div>
    </section>
)
}

export default OptInfoWrapp
